import { render, staticRenderFns } from "./domainNamerSuccess.vue?vue&type=template&id=6efa2157&"
import script from "./domainNamerSuccess.vue?vue&type=script&lang=js&"
export * from "./domainNamerSuccess.vue?vue&type=script&lang=js&"
import style0 from "./domainNamerSuccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports